import { supabase } from "@/integrations/supabase/client";

export type InternalAnalyticsEvent =
  | "session"
  | "page_view"
  | "consent_banner_view"
  | "consent_granted"
  | "consent_denied"
  | "affiliate_click";

const SESSION_TRACKED_KEY = "internal_analytics_session_tracked";

export const trackInternalEvent = async (
  eventName: InternalAnalyticsEvent,
): Promise<void> => {
  const { error } = await supabase
    .from("analytics_ingest")
    .insert({ event_name: eventName });

  if (error) {
    console.error("Internal analytics event failed:", eventName, error.message);
  }
};

export const trackSessionOnce = (): void => {
  try {
    if (sessionStorage.getItem(SESSION_TRACKED_KEY)) return;
    sessionStorage.setItem(SESSION_TRACKED_KEY, "1");
    void trackInternalEvent("session");
  } catch {
    void trackInternalEvent("session");
  }
};